import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { patentStateOptions } from '@/module/Nomen/PatentState/model/PatentStateModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type PatentStateSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function PatentStateSelectControl<T extends FieldValues>(props: PatentStateSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(patentStateOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
